import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9jd96k047p: FaireBrandEntity = {
  token: "b_9jd96k047p",
  type: "brand",
  name: "Rishi Tea & Botanicals",
  avatarUrl:
    "https://cdn.faire.com/fastly/9df42a2a7b022cae52ac3917363794c0e29f977c1c310f041685a1d1357c730f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/180f5be751610d8c2f85c3d4835a5dd65b90f0325affc23083a1db4e1a0f0619.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9df42a2a7b022cae52ac3917363794c0e29f977c1c310f041685a1d1357c730f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/180f5be751610d8c2f85c3d4835a5dd65b90f0325affc23083a1db4e1a0f0619.jpeg",
  location: "Milwaukee, WI, USA",
  minimumOrderDollars: 346,
  rating: 5,
  reviewCount: 89,
  isTopShop: true,
  isInsider: true,
  description:
    "Rishi Tea was founded on the commitment to set the standard for quality and expand the awareness of tea and its rich, inspirational tradition. We offer premium tea and botanicals imported directly from gardens across the world. We draw inspiration from ancient artisanal practices that use organic cultivation techniques as well as modern culinary innovation. From our modest beginnings over twenty years ago to becoming an established leader in the specialty tea market, our mission has never wavered.\n\nMissing Sparkling Botanicals? Find it here! https://faire.com/direct/sparklingbotanicals",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:28.424Z",
    importedBy: "entity-db-cli",
  },
};
